import React from 'react';
import { Download } from 'react-feather';
import { List } from '../../core/List';
import { Card } from '../../core/Card';

import "./SkusIntegrity.css";

export const SkusIntegrity = () => {


    return (
        <Card title='Health' subtitle='Check skus integrity health here'>
            <div className="skus-health">

                <List
                    controller='api/esko/health/sku/incomplete'
                    action=''
                    headers={[
                        { column: 'globalOrderId', title: 'Order Number', sortable: true },
                        { column: 'skuId', title: 'Sku Number', sortable: true },
                        { column: 'metadataUploaded', title: 'MetaData', sortable: true },
                        { column: 'artworkUploaded', title: 'Artwork', sortable: true },
                        { column: 'thumbnailUploaded', title: 'Thumbnail', sortable: true },
                        { column: 'printFileUploaded', title: 'PrintFile', sortable: false },
                        { column: 'error', title: 'Error', sortable: false }
                    ]}
                    onRenderRow={(column, item, header) => {
                        switch (column) {
                            case 'download':
                                return (<span title="Download"><Download onClick={() => window.location.href = "/api/esko/file/" + item.id}></Download></span>)
                            case 'metadataUploaded':
                            case 'artworkUploaded':
                            case 'thumbnailUploaded':
                            case 'printFileUploaded':
                                return (<div className={"field-status-indicator " + (item[column] ? "valid" : "invalid")}></div>)
                            default:
                                if (item[column] != null) {
                                    return (<span>{item[column]}</span>);
                                }
                        }
                    }}
                />
            </div>
        </Card>
    )
}